// src/components/molecules/UserProfile/Edit/DisplayNameInput.js

import React from "react";

const DisplayNameInput = ({ displayName, handleChange }) => {
  return (
    <input
      type="text"
      name="displayName"
      value={displayName}
      onChange={handleChange}
      style={{
        width: "100%",
        backgroundColor: "#868A9C",
        color: "white",
        padding: "10px",
        border: "none",
        borderRadius: "4px",
        fontFamily: "basic-sans",
      }}
    />
  );
};

export default DisplayNameInput;
